import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledMobileHeader = styled.div`
  display: none;
  z-index: 1000;
  width: 100%;
  .mobile-header-container {
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 1200;
    box-shadow: 0px 4px 12px ${({ theme }) => theme.boxShadowColor};

    .mobile-image-container {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      height: 60px;
      background-color: ${({ theme }) => theme.brand01};
      z-index: 1001;

      > div > img {
        height: 100%;
      }
    }
  }

  .filter-open-btn {
    display: flex;
    height: auto;
    padding: 11px 14px !important;
    border-radius: 5px;
  }

  .filter-open-btn:hover {
    background: ${({ theme }) => theme.brand01} !important;
    border-color: ${({ theme }) => theme.colorBorder} !important;
    color: ${({ theme }) => theme.white} !important;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: flex;
    .mobile-header-container {
      width: 100%;

      &.filterOpen {
        .buy-latvia-food {
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .title-section {
            width: 300px;
            justify-content: center;
            padding: 0 0 0 0;
          }

          .counter-section {
            position: absolute;
            padding: 0 0 0 0;
            flex-direction: row;
            gap: 10px;
            top: 154px;
            background-color: ${({ theme }) => theme.filterSelectBg};
            max-width: 120px;
            border-radius: 10px;
            padding: 2px 5px 2px 5px;
            color: white;

            h3 {
              font-size: 1rem;
              b {
                font-size: 1rem;
              }
            }
          }
        }
      }
    }

    .buy-latvia-food {
      display: flex;
      gap: 8px;
      width: 100%;
      background-color: ${({ theme }) => theme.white};
      justify-content: space-between;

      .title-section {
        max-width: 175px;
        height: 100%;
        display: flex;
        align-items: center;
        margin: 24px 0px 24px 18px;

        h3 {
          font-family: ${({ theme }) => theme.fontText};
          margin: 0;
          font-weight: 400;
          font-size: 24px;
        }
      }

      .counter-section {
        width: 60px;
        display: flex;
        flex-direction: column;
        align-items: end;
        margin: auto 18px 24px 0;

        h3 {
          font-family: ${({ theme }) => theme.fontText};
          margin: 0;
          font-weight: 400;
          font-size: 14px;

          b {
            font-size: 18px;
          }
        }
      }
    }

    .search-section {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 9px 20px 25px 20px;
      padding-right: 10px;
      background-color: ${({ theme }) => theme.inputGrey};
    }

    .fixed-search-section {
      position: fixed !important;
      top: 0px !important;
      z-index: 1;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .buy-latvia-food {
      .title-section {
        max-width: 200px;

        h3 {
          font-size: 1.5rem;
          b {
            font-size: 1.5rem;
          }
        }
      }

      .counter-section {
        h3 {
          font-size: 0.875rem;
          b {
            font-size: 1.125rem;
          }
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .buy-latvia-food {
      .title-section {
        max-width: 180px !important;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .mobile-header-container.filterOpen .buy-latvia-food .counter-section {
      top: 165px;
    }

    .filterOpen .buy-latvia-food {
      height: 94px;
      margin-top: 23px;
      margin-bottom: 22px;
    }
  }
`;
